/**
 * Bind all methods on the instance + its prototype to the instance. If
 * `traversePrototypeChain` is true, the prototype chain will be traversed until
 * Object.prototype is reached, and any additional methods found will be included.
 * @param instance The instance to bind methods to
 * @param traversePrototypeChain Whether to traverse the prototype chain or not
 */
export function bindAllMethods(instance) {
  var traversePrototypeChain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var methodNames = getAllMethodNames(instance, traversePrototypeChain);
  methodNames.forEach(methodName => {
    // eslint-disable-next-line no-param-reassign
    instance[methodName] = instance[methodName].bind(instance);
  });
}

/**
 * Get all class method names. This will return names of all methods defined on
 * the instance + its prototype. If `traversePrototypeChain` is true, the prototype
 * chain will be traversed until Object.prototype is reached, and any additional
 * methods found will be included.
 * @param instance Instance to get method names from
 * @param traversePrototypeChain Whether to traverse the prototype chain or not
 */
export function getAllMethodNames(instance, traversePrototypeChain) {
  var methodNames = new Set();
  var current = instance;

  // Get method names for instance + prototype. Optionally traverse prototype
  // chain until Object.prototype is reached.
  var level = 0;
  while (current != null && current !== Object.prototype && (level <= 1 || traversePrototypeChain)) {
    // eslint-disable-next-line no-restricted-syntax
    for (var name of Object.getOwnPropertyNames(current)) {
      var _Object$getOwnPropert;
      if (name !== 'constructor' &&
      // Ensure this is a method and not a getter
      typeof ((_Object$getOwnPropert = Object.getOwnPropertyDescriptor(current, name)) === null || _Object$getOwnPropert === void 0 ? void 0 : _Object$getOwnPropert.value) === 'function') {
        methodNames.add(name);
      }
    }
    current = Object.getPrototypeOf(current);
    level += 1;
  }
  return [...methodNames.keys()];
}
//# sourceMappingURL=ClassUtils.js.map